import React from "react";
import { CheckCircle2, XCircle } from "lucide-react";

export const ONE_DAY_MS = 24 * 60 * 60 * 1000;

export function timeAgo(iso) {
  if (!iso) return "never";
  const diff = Date.now() - new Date(iso).getTime();
  if (diff < 60_000) return "just now";
  if (diff < 3_600_000) return `${Math.floor(diff / 60_000)} min ago`;
  if (diff < 86_400_000) return `${Math.floor(diff / 3_600_000)} hr ago`;
  return `${Math.floor(diff / 86_400_000)} day${Math.floor(diff / 86_400_000) === 1 ? "" : "s"} ago`;
}

export function Bool({ v }) {
  return v ? (
    <CheckCircle2 className="w-4 h-4 text-emerald-400" />
  ) : (
    <XCircle className="w-4 h-4 text-slate-600" />
  );
}

export function StatCell({ label, value, tone }) {
  const color = tone === "emerald" ? "text-emerald-400" : "text-white";
  return (
    <div className="border border-surface-3 bg-surface p-4">
      <div className="text-[10px] font-condensed uppercase tracking-[0.28em] text-slate-500">{label}</div>
      <div className={`font-display text-3xl mt-1 ${color}`}>{value}</div>
    </div>
  );
}
